define((require) => {
    "use strict";

    const _               = require("underscore");
    const Backbone        = require("backbone");
    const Spinner         = require("spin");
    const $               = require("jquery");

    /**
     * Simple <tt>Backbone</tt> view wrapping a "spinner".
     *
     * @class SpinnerView
     */
    return Backbone.View.extend({

        render() {
            const options = _.defaults(this.options, {
                color: "#000"
            });
            const spinner = new Spinner(options).spin();
            const element = $(spinner.el).css({
                position: "absolute",
                top: "50%",
                left: "50%"
            });

            this.$el.append(element);

            return this;
        },

        destroy() {
            this.$el.remove();
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/common/SpinnerView.js